<template>
    <div>
        <div class="dataTitle">
            <div class="title">{{title}}</div>
            <div style="display: flex;justify-content: center;align-items: center;">
                <InputField label="" type="text" label-width="0%" id="areaName" style="margin-right: 1rem;"
                            :modelValue="preForm.areaName" placeholder="请输入区域名称"
                            @update:modelValue="(value) => handleModelPreValueUpdate('areaName', value)"/>
                <a-space>
                    <ButtonField style="width: 80px;" text="查询" secondary @click="getUnderSurfGrnPageList"/>
                    <ButtonField style="width: 80px;" text="新增" @click="add" primary />
                </a-space>
            </div>
        </div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="preForm.totalSize"
            :totalPages="preForm.totalPages"
            :pageNum="preForm.pageNum"
            :pageSize="preForm.pageSize"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>
        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="editShow?'编辑下垫面及绿地':'新增下垫面及绿地'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <div>
                        <InputField label="区域名称" type="text"  id="areaName" labelWidth="80%"
                                    :modelValue="form.areaName" placeholder="请输入区域名称"
                                    @update:modelValue="(value) => handleModelValueUpdate('areaName', value)"/>
                    </div>
                    <div>
                        <SelectField label="下垫面类型" id="type" placeholder="下垫面类型" labelWidth="75%"
                                     :modelValue="form.underlying" :options="underlyingList"
                                     @update:modelValue="(value) => handleModelValueUpdate('underlying', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="不透水率(%)" type="Number"  id="waterproof" labelWidth="80%"
                                    :modelValue="form.waterproof" placeholder="请输入不透水率(%)"
                                    @update:modelValue="(value) => handleModelValueUpdate('waterproof', value)"/>
                    </div>
                    <div>
                        <InputField label="种植屋面面积(平方米)" type="Number"  id="roofArea" labelWidth="80%"
                                    :modelValue="form.roofArea" placeholder="请输入种植屋面面积(平方米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('roofArea', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="公园绿地面积(平方米)" type="Number"  id="greenArea" labelWidth="80%"
                                    :modelValue="form.greenArea" placeholder="请输入公园绿地面积(平方米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('greenArea', value)"/>
                    </div>
                    <div>
                        <InputField label="可调蓄容积(立方米)" type="Number"  id="volume" labelWidth="80%"
                                    :modelValue="form.volume" placeholder="请输入可调蓄容积(立方米)"
                                    @update:modelValue="(value) => handleModelValueUpdate('volume', value)"/>
                    </div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
<!--                        <ButtonField text="下一步" v-else primary @click="handleNextStep"/>-->
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import { fetchUnderSurfGrnPageList,saveUnderSurfGrnPage,modifyUnderSurfGrnPage,remove,} from "@/views/diagnose/api/diagnose";

export default {
    name: "index",
    data() {
        return {
            preForm:{
                totalSize: 1,
                totalPages: 1,
                pageNum: 1,
                pageSize: 10,
            },
            form:{
                areaName:null,underlying:null,waterproof:null,roofArea:null,greenArea:null,volume:null
            },
            visible:false,
            editShow:false,
            saveShow:false,
            underlyingList:[
                {name:'建筑',value:1},{name:'道路',value:2},{name:'绿地',value:3},{name:'水体',value:4},{name:'裸土',value:5},
            ],
            list:[],
            tableColumns:[
                {key: 'areaName',title: '区域名称',field: 'areaName',width: '100px'},
                {key: 'underlying',title: '下垫面类型',field: 'underlying',width: '100px'},
                {key: 'waterproof',title: '不透水率（%）',field: 'waterproof',width: '100px'},
                {key: 'roofArea',title: '种植屋面面积（平方米）',field: 'roofArea',width: '100px'},
                {key: 'greenArea',title: '公园绿地面积（平方米）',field: 'greenArea',width: '100px'},
                {key: 'volume',title: '可调蓄容积（立方米）',field: 'volume',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ]
        }
    },
    props:{
        title: {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.getUnderSurfGrnPageList();
    },
    methods: {
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        onChange(pagination) {
            this.preForm.pageNum  = pagination;
            this.preForm.pageSize = 10;
            this.getUnderSurfGrnPageList();
        },
        getUnderSurfGrnPageList(){
            fetchUnderSurfGrnPageList(this.preForm).then(res => {
                this.list = res.list.map(item => ({
                    ...item,
                    daytime: this.formatDate(item.daytime)
                }));
                this.preForm.totalPages = res.totalPages;
                this.preForm.totalSize = res.totalSize;
            })
        },
        handleModelPreValueUpdate(fieldName, value){
            this.preForm[fieldName] = value;
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        add(){
            this.visible = true;
            this.editShow = false;
            this.saveShow = false;
            this.form = {}
        },
        editText(item){
            console.log("item:::",item)
            this.visible = true;
            this.editShow = true;
            this.saveShow = false;
            this.form = item;
        },
        deleteText(item){
            console.log("item:::",item)
            remove({
                id: item.id,
                type: "diagnose_under_surf_grn"
            }).then((res) => {
                console.log("res:", res);
                this.getUnderSurfGrnPageList();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        cancel() {
            this.visible = false;
        },
        handleSubmit(){
            this.form.daytime = new Date();
            if(this.form.id){
                modifyUnderSurfGrnPage(this.form).then(res => {
                    console.log("modifyUnderSurfGrnPage   res:::",res)
                    this.getUnderSurfGrnPageList()
                })
            }else{
                saveUnderSurfGrnPage(this.form).then(res => {
                    console.log("saveUnderSurfGrnPage   res:::",res)
                    this.getUnderSurfGrnPageList()
                })
            }
            this.saveShow = true
            this.visible = false;
        },
        handleNextStep(){
            this.visible = false;
        }
    }
}
</script>
<style scoped>
.dataTitle{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 1rem 0;
}
.title{
    font-size: 1.2rem;
    color: #00ff96;
    font-weight: bold;
}
.formDiv{
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
}
.formDiv > div{
    width: 48%;
}
</style>